import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Icons } from '../constants';

const RegisterBusinessForm: React.FC = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    ownerName: '',
    email: '',
    website: '',
    serviceArea: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      await addDoc(collection(db, 'businesses'), {
        ...formData,
        registrationDate: new Date().toISOString()
      });
      setIsSubmitted(true);
    } catch (err) {
      console.error(err);
      setError('Registration failed. Please try again.');
    }
  };

  if (isSubmitted) {
    return (
      <div className="bg-white p-8 rounded-[32px] border border-stone-200 shadow-sm text-center">
        <Icons.Tree className="w-16 h-16 text-gecko mx-auto mb-4" />
        <h2 className="text-2xl font-black text-bark mb-2">Registration Received!</h2>
        <p className="text-stone-500">Thank you for registering your business with GreenTree. Our team will review your application soon.</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-8 rounded-[32px] border border-stone-200 shadow-sm max-w-lg mx-auto">
      <h2 className="text-2xl font-black text-bark mb-6">Register Your Tree Care Business</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <input 
          type="text" 
          placeholder="Business Name"
          className="w-full p-3 rounded-xl border border-stone-200"
          value={formData.businessName}
          onChange={e => setFormData({...formData, businessName: e.target.value})}
          required
        />
        <input 
          type="text" 
          placeholder="Owner Name"
          className="w-full p-3 rounded-xl border border-stone-200"
          value={formData.ownerName}
          onChange={e => setFormData({...formData, ownerName: e.target.value})}
          required
        />
        <input 
          type="email" 
          placeholder="Email Address"
          className="w-full p-3 rounded-xl border border-stone-200"
          value={formData.email}
          onChange={e => setFormData({...formData, email: e.target.value})}
          required
        />
        <input 
          type="url" 
          placeholder="Website"
          className="w-full p-3 rounded-xl border border-stone-200"
          value={formData.website}
          onChange={e => setFormData({...formData, website: e.target.value})}
        />
        <input 
          type="text" 
          placeholder="Service Area (e.g. Columbus, GA)"
          className="w-full p-3 rounded-xl border border-stone-200"
          value={formData.serviceArea}
          onChange={e => setFormData({...formData, serviceArea: e.target.value})}
          required
        />
        <button 
          type="submit"
          className="w-full p-3 bg-gecko text-white rounded-xl font-bold hover:bg-palm transition"
        >
          Register Business
        </button>
      </form>
    </div>
  );
};

export default RegisterBusinessForm;
